/**
 * Instagram-Style Product Slider Dots + Rating Badge
 * Rating format: 4.3 ★ (226)
 * Position: Bottom-left corner
 */
(function() {
  'use strict';

  // ==========================================
  // RATING BADGE - Extract from Judge.me
  // ==========================================
  
  function createRatingBadge() {
    // Remove existing badge if any
    const existing = document.getElementById('custom-rating-badge');
    if (existing) existing.remove();

    // Find Judge.me badge element
    const jdgmBadge = document.querySelector('.jdgm-prev-badge, [data-average-rating]');
    
    if (!jdgmBadge) {
      console.log('[Rating] Judge.me badge not found, retrying...');
      setTimeout(createRatingBadge, 500);
      return;
    }

    // Extract rating data
    const rating = jdgmBadge.getAttribute('data-average-rating');
    const reviews = jdgmBadge.getAttribute('data-number-of-reviews');

    if (!rating || parseFloat(rating) === 0) {
      console.log('[Rating] No rating data found');
      return;
    }

    console.log(`[Rating] Found: ${rating} stars, ${reviews} reviews`);

    // Find the slider component to place badge
    const sliderComponent = document.querySelector('[id^="GalleryViewer-"]');
    if (!sliderComponent) {
      console.log('[Rating] Slider component not found');
      return;
    }

    // Create badge element with format: 4.3 ★ (226)
    const badge = document.createElement('div');
    badge.id = 'custom-rating-badge';
    badge.innerHTML = `
      <span class="crb-rating">${parseFloat(rating).toFixed(1)}</span>
      <span class="crb-star">★</span>
      <span class="crb-count">(${reviews})</span>
    `;

    // Insert into slider component
    sliderComponent.style.position = 'relative';
    sliderComponent.insertBefore(badge, sliderComponent.firstChild);

    console.log('[Rating] Badge created successfully');
  }

  // ==========================================
  // INSTAGRAM DOTS
  // ==========================================
  
  class InstagramDots {
    constructor() {
      this.container = null;
      this.track = null;
      this.dots = [];
      this.currentIndex = 0;
      this.totalImages = 0;
      this.maxVisible = 5;
      this.dotSize = 6;
      this.dotGap = 6;
      this.slider = null;
      this.sliderComponent = null;
      this.mediaItems = [];
      this.observer = null;
      
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
      
      window.addEventListener('load', () => {
        if (!this.container) this.setup();
        createRatingBadge();
      });
    }

    setup() {
      const sectionId = this.findSectionId();
      if (!sectionId) {
        setTimeout(() => this.setup(), 200);
        return;
      }

      this.sliderComponent = document.querySelector(`#GalleryViewer-${sectionId}`);
      this.slider = document.querySelector(`#Slider-Gallery-${sectionId}`);

      if (!this.slider || !this.sliderComponent) {
        setTimeout(() => this.setup(), 200);
        return;
      }

      this.mediaItems = this.getVisibleMediaItems();
      this.totalImages = this.mediaItems.length;

      if (this.totalImages < 2) {
        console.log('[Dots] Less than 2 images');
        setTimeout(createRatingBadge, 100);
        return;
      }

      console.log(`[Dots] Found ${this.totalImages} images`);

      this.createDots();
      this.updateDots(0);
      this.setupObserver();
      this.setupEventListeners();
      this.setupVariantListener();
      
      setTimeout(createRatingBadge, 100);
      
      console.log('[Dots] Initialized');
    }

    findSectionId() {
      const gallery = document.querySelector('media-gallery[id^="MediaGallery-"]');
      if (gallery) return gallery.id.replace('MediaGallery-', '');
      
      const viewer = document.querySelector('[id^="GalleryViewer-"]');
      if (viewer) return viewer.id.replace('GalleryViewer-', '');
      
      return null;
    }

    getVisibleMediaItems() {
      const items = this.slider.querySelectorAll('.product__media-item');
      return Array.from(items).filter(item => {
        const style = window.getComputedStyle(item);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    createDots() {
      document.querySelectorAll('.ig-dots').forEach(el => el.remove());

      this.container = document.createElement('div');
      this.container.className = 'ig-dots';

      this.track = document.createElement('div');
      this.track.className = 'ig-dots__track';

      this.dots = [];
      for (let i = 0; i < this.totalImages; i++) {
        const dot = document.createElement('button');
        dot.className = 'ig-dots__dot';
        dot.type = 'button';
        dot.dataset.index = i;
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToSlide(i);
        });

        this.track.appendChild(dot);
        this.dots.push(dot);
      }

      this.container.appendChild(this.track);
      this.sliderComponent.appendChild(this.container);
    }

    updateDots(activeIndex) {
      if (!this.dots.length) return;
      
      this.currentIndex = activeIndex;
      
      this.dots.forEach((dot, i) => {
        dot.className = 'ig-dots__dot';
        
        const distance = Math.abs(i - activeIndex);
        
        if (i === activeIndex) {
          dot.classList.add('is-active');
        } else if (distance === 1) {
          dot.classList.add('is-near');
        } else if (distance === 2) {
          dot.classList.add('is-far');
        } else {
          dot.classList.add('is-hidden');
        }
      });

      this.slideTrack(activeIndex);
    }

    slideTrack(activeIndex) {
      if (!this.track) return;
      
      const total = this.totalImages;
      const maxVisible = this.maxVisible;
      
      if (total <= maxVisible) {
        this.track.style.transform = 'translateX(0)';
        return;
      }

      const unit = this.dotSize + this.dotGap;
      const center = Math.floor(maxVisible / 2);
      
      let offset = (activeIndex - center) * unit;
      
      const minOffset = 0;
      const maxOffset = (total - maxVisible) * unit;
      
      if (offset < minOffset) offset = minOffset;
      if (offset > maxOffset) offset = maxOffset;
      
      this.track.style.transform = `translateX(-${offset}px)`;
    }

    setupObserver() {
      if (this.observer) this.observer.disconnect();

      this.observer = new IntersectionObserver((entries) => {
        let best = null;
        let bestRatio = 0;
        
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > bestRatio) {
            bestRatio = entry.intersectionRatio;
            best = entry.target;
          }
        });

        if (best) {
          const idx = this.mediaItems.indexOf(best);
          if (idx !== -1 && idx !== this.currentIndex) {
            this.updateDots(idx);
          }
        }
      }, {
        root: this.slider,
        threshold: [0.5, 0.75, 1]
      });

      this.mediaItems.forEach(item => this.observer.observe(item));
    }

    setupEventListeners() {
      let timeout;
      this.slider.addEventListener('scroll', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => this.detectCurrentSlide(), 100);
      }, { passive: true });

      this.slider.addEventListener('touchend', () => {
        setTimeout(() => this.detectCurrentSlide(), 150);
      }, { passive: true });

      const prev = this.sliderComponent.querySelector('.slider-button--prev');
      const next = this.sliderComponent.querySelector('.slider-button--next');
      prev?.addEventListener('click', () => setTimeout(() => this.detectCurrentSlide(), 100));
      next?.addEventListener('click', () => setTimeout(() => this.detectCurrentSlide(), 100));
    }

    detectCurrentSlide() {
      if (!this.slider || !this.mediaItems.length) return;

      const rect = this.slider.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      
      let closest = 0;
      let minDist = Infinity;

      this.mediaItems.forEach((item, i) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const dist = Math.abs(itemCenter - center);
        
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });

      if (closest !== this.currentIndex) {
        this.updateDots(closest);
      }
    }

    setupVariantListener() {
      let lastUrl = location.href;
      const check = () => {
        if (location.href !== lastUrl) {
          lastUrl = location.href;
          setTimeout(() => this.reinit(), 300);
        }
      };
      
      window.addEventListener('popstate', check);
      
      document.addEventListener('variant:change', () => {
        setTimeout(() => this.reinit(), 300);
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-option-value], .swatch, .color-swatch, input[type="radio"]')) {
          setTimeout(() => this.reinit(), 400);
        }
      });

      if (this.slider) {
        new MutationObserver(() => {
          clearTimeout(this.mutTimer);
          this.mutTimer = setTimeout(() => {
            const newItems = this.getVisibleMediaItems();
            if (newItems.length !== this.totalImages) {
              this.reinit();
            }
          }, 200);
        }).observe(this.slider, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }

    reinit() {
      console.log('[Dots] Reinitializing...');
      this.observer?.disconnect();
      document.querySelectorAll('.ig-dots').forEach(el => el.remove());
      this.container = null;
      this.track = null;
      this.dots = [];
      this.currentIndex = 0;
      this.setup();
    }

    goToSlide(index) {
      if (index < 0 || index >= this.mediaItems.length) return;
      
      this.mediaItems[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      
      this.updateDots(index);
    }
  }

  // ==========================================
  // INITIALIZE
  // ==========================================
  
  if (window.instagramDots) {
    window.instagramDots.observer?.disconnect();
    document.querySelectorAll('.ig-dots').forEach(el => el.remove());
  }
  
  window.instagramDots = new InstagramDots();

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      setTimeout(() => {
        window.instagramDots?.reinit();
        createRatingBadge();
      }, 100);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(createRatingBadge, 500);
    });
  } else {
    setTimeout(createRatingBadge, 500);
  }
})();